<style lang="stylus" scoped>
.progress {
  height: 12px;
  border: none;
  background: #e8e8e8;
  box-shadow: none;
  padding: 0;
}

.progress-bar {
  transition: width 1.5s ease-in-out;
  background: #78BE20 !important;
  box-shadow: none;
  height: 100%;
  margin: 0;
  padding: 0;
}

.whiteCircle {
  border: 1px solid #fff;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  background: #fff;
  font-size: 12px;
  padding: 5px 7px;
  font-weight: 500;
  margin-bottom: 0px;
  color: #28a745;
}

:deep(.v-expansion-panel-text__wrapper) {
  padding: 0 !important;
}

:deep(.v-expansion-panel-title) {
  min-height: auto;
}

.card-border-background {
  border: 3px solid rgb(0, 0, 0, 0.05);
  padding: 15px 10px 15px 10px;
}

.whiteRound {
  background-color: #fff;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 2px;
  border-radius: 50%;
  height: 30px;
  font-weight: 600;
  margin-right: 3px;
}

.grayText {
  padding-right: 10px;
  padding-top: 2px;
  border-radius: 50%;
  height: 30px;
  font-weight: 600;
  color: #747474;
  opacity: 1;
}

.whiteRound2 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #fff;
  color: #66a11b;
  font-weight: bold;
  font-size: 16px;
  margin-right: 3px;
}
</style>

<style>
.custom-info-tooltip {
  background-color: #000 !important;
  color: #fff !important;
  padding: 10px !important;
  text-align: left !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3) !important;
}

@media (max-width: 600px) {
  .custom-info-tooltip {
    max-width: calc(100vw - 2rem) !important;
  }
}
</style>

<template>
  <div>
    <v-row style="margin: 0 0.6rem 2rem">
      <v-row>
        <div
          ref="progressCard"
          class="d-flex flex-column"
          style="border: 1px solid #d0d0d0; border-radius: 8px; width: 100%; padding: 24px; gap: 12px; background: #fff"
        >
          <!-- Title + info icon -->
          <div class="d-flex align-center justify-space-between">
            <div
              class="font-weight-bold"
              style="
                font-family: Arial, sans-serif;
                font-size: 20px;
                line-height: 26px;
                letter-spacing: -0.6px;
                color: #191919;
              "
            >
              Credits toward General Admission
            </div>
            <v-tooltip
              location="bottom end"
              width="360"
              content-class="custom-info-tooltip"
              :open-on-hover="true"
              :open-on-click="true"
            >
              <template #activator="{ props }">
                <v-icon
                  v-bind="props"
                  size="24"
                  color="#747474"
                  class="mobile-touch-target-icon"
                  style="cursor: pointer"
                >
                  mdi-information-outline
                </v-icon>
              </template>
              <div style="font-size: 16px; line-height: 1.6">
                You need a total of {{ totalCredits }} credits with a minimum of 2.75 GPA to earn general admission to
                ASU. Please note that if you enrolled in a pathway, your requirements may differ.
              </div>
            </v-tooltip>
          </div>

          <!-- GPA box -->
          <div
            class="d-flex flex-column align-center justify-center"
            style="background: #fafafa; border-radius: 8px; padding: 8px 0"
          >
            <div
              :style="{
                fontFamily: 'Arial, sans-serif',
                fontWeight: '700',
                fontSize: '64px',
                lineHeight: '68px',
                letterSpacing: '-1.92px',
                color: gpaColor
              }"
            >
              {{ currentGPA }}
            </div>
            <div
              style="
                font-family: Arial, sans-serif;
                font-weight: 700;
                font-size: 16px;
                line-height: 24px;
                letter-spacing: -0.48px;
                color: #191919;
                text-align: center;
              "
            >
              GPA
            </div>
            <div style="font-family: Arial, sans-serif; font-size: 14px; line-height: 18px; color: #747474">
              Minimum GPA required is {{ minGPAValue(minGPA) }}
            </div>
          </div>

          <!-- Credits completed -->
          <div class="d-flex flex-column" style="gap: 4px">
            <div
              class="font-weight-bold"
              style="
                font-family: Arial, sans-serif;
                font-size: 16px;
                line-height: 24px;
                letter-spacing: -0.48px;
                color: #191919;
              "
            >
              Credits completed
            </div>
            <div
              class="d-flex justify-space-between"
              style="font-family: Arial, sans-serif; font-size: 16px; line-height: 24px; color: #747474"
            >
              <span>{{ Math.round(creditCompletionPercentage) }}%</span>
              <span>{{ earnedCredits }}/{{ totalCredits }} Credits</span>
            </div>
            <div class="progress">
              <div
                class="progress-bar progress-bar-warning"
                role="progressbar"
                aria-valuenow="70"
                aria-valuemin="0"
                aria-valuemax="100"
                v-bind:style="{ width: Math.max(creditCompletionPercentage, 3.2) + '%' }"
              />
            </div>
          </div>

          <!-- Estimate new GPA -->
          <v-expansion-panels>
            <v-expansion-panel elevation="0">
              <v-expansion-panel-title
                style="padding: 0px !important"
                class="d-flex justify-space-between align-center mobile-touch-target"
              >
                <div
                  style="
                    font-family: Arial, sans-serif;
                    font-size: 16px;
                    line-height: 24px;
                    color: #747474;
                    flex: 0 0 auto;
                  "
                  @click="asuoDataLayerClick('myProgress', '0')"
                >
                  Estimate new GPA
                </div>
                <template v-slot:actions="{ expanded }">
                  <v-icon size="16" color="#747474">
                    {{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                  </v-icon>
                </template>
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <current-GPA :GPA="currentGPA" :showTitle="false" :noBorder="true">
                  <template #header>
                    <span class="mt-2" style="font-size: 16px; font-weight: 600; display: block"
                      >Enter your anticipated grades for your In-progress courses:</span
                    >
                  </template>
                </current-GPA>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-row>
    </v-row>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapState } from 'pinia';
import { useUserStore } from '@/stores/user';

import { DataLayerMixin } from '../../../src/mixins/dataLayerMixin';

export default defineComponent({
  name: 'MyProgressComponent',
  data() {
    return {
      animatedWidth: 0,
      hasAnimated: false
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll(); // Check immediately
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  mixins: [DataLayerMixin],
  components: {},

  props: {
    earnedCredits: {
      type: Number,
      required: true
    },
    totalCredits: {
      type: Number,
      required: true
    },

    pathwayCompletionDate: String,
    minGPA: Number,
    pathwayName: String
  },

  methods: {
    handleScroll() {
      if (this.hasAnimated) return;

      const element = this.$refs.progressCard;
      if (!element) return;

      const rect = element.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      if (rect.top < windowHeight - 100) {
        this.hasAnimated = true;
        setTimeout(() => {
          this.animatedWidth = this.creditCompletionPercentage;
        }, 200);
      }
    },
    isPathwayHasConnection() {
      const learnerData = this.getLearnerData;
      return learnerData?.pathwayId;
    },
    minGPAValue() {
      return this.minGPA % 1 === 0 ? this.minGPA.toFixed(1) : this.minGPA;
    }
  },

  computed: {
    ...mapState(useUserStore, ['getLearnerData']),
    isPathwaysAllowed() {
      return this.$conn.learnerData._isPathwaysAllowed;
    },
    currentGPA() {
      const learnerData = this.getLearnerData;
      let num = learnerData?._currentGPA;

      return Number.parseFloat(num || 0).toFixed(2);
    },
    creditCompletionPercentage() {
      return (this.earnedCredits / this.totalCredits) * 100;
    },

    creditDifference() {
      return this.totalCredits - this.earnedCredits;
    },

    requiredCredits() {
      return this.creditDifference >= 0 ? this.creditDifference : 0;
    },
    gpaColor() {
      const gpa = parseFloat(this.currentGPA);
      if (gpa === 0) {
        return '#747474'; // Gray if no completed credits
      } else if (gpa < 2.75) {
        return '#8C1D40'; // Maroon if below 2.75
      } else {
        return '#78BE20'; // Green if 2.75 or higher
      }
    }
  }
});
</script>
